<article class="card" [attr.data-chart]="vm?.chart">
  <header class="card__heading">
    <h2 class="card__title">{{ vm?.title }}</h2>
    <p class="card__subtitle">{{ vm?.subtitle }}</p>
  </header>
  <div class="card__body">
    <ng-container *ngIf="!vm?.isEmpty; else empty">
      <div class="card__canvas" role="img" [attr.aria-label]="vm?.ariaLabel" [style.height]="canvasHeight">
        <ifc-bar-chart [data]="vm?.data" [options]="vm?.options"></ifc-bar-chart>
      </div>
      <p class="card__more" *ngIf="moreLabel">{{ moreLabel }}</p>
    </ng-container>
    <ng-template #empty>
      <p class="card__empty">{{ vm?.emptyMessage }}</p>
    </ng-template>
  </div>
  <footer class="card__footer">
    <a
      mat-button
      class="card__report"
      *ngIf="vm?.link"
      [routerLink]="vm.link.route"
      [queryParams]="vm.link.queryParams"
    >
      VIEW REPORT
    </a>
    <span class="card__footer-label">{{ vm?.footerLabel }}</span>
  </footer>
</article>
